import './Portada.css';
import React from 'react'

const Portada = () => {
  return (
    <div className='portada'>
        <h1>
          <span className='PaolaJofrePortada'>
            PAOLA JOFRE
          </span> <br/> 
          <span className='SkinCarePortada'>
            Skin Care
          </span>
        </h1>
    </div>
  )
}

export default Portada